import { ReactNode, createContext, useEffect, useRef, useState } from "react";

import { IGroup } from "pages/[tenant]/g/@types";

import { IBillboardHighlight, IBillboardSection } from "shared/types/billboard";

import { IBillboardPageContextProps } from "../types";

export const BillboardPageContext = createContext(
  {} as IBillboardPageContextProps,
);

interface IBillboardPageProviderProps {
  children: ReactNode;
  SSRhighlights: IBillboardHighlight[];
  SSRsections: IBillboardSection[];
}

export const BillboardPageProvider = ({
  children,
  SSRsections,
  SSRhighlights,
}: IBillboardPageProviderProps) => {
  const [group, setGroup] = useState<IGroup>(null);
  const [hasSound, setHasSound] = useState(false);
  const [videoTimeDuration, setVideoTimeDuration] = useState(10000);
  const pandaPlayerRef = useRef<HTMLIFrameElement>(null);
  const [highlights, setHighlights] = useState<IBillboardHighlight[]>(
    SSRhighlights ?? [],
  );
  const [sections, setSections] = useState<IBillboardSection[]>(
    SSRsections ?? [],
  );

  const [backgroundContent, setBackgroundContent] = useState<"video" | "image">(
    "video",
  );

  useEffect(() => {
    setHighlights(SSRhighlights);
    setSections(SSRsections);
  }, [SSRsections, SSRhighlights]);

  const handleToggleSound = ({ pandaPlayerRef }) => {
    if (!pandaPlayerRef) return;

    setHasSound(!hasSound);
    const iframe = pandaPlayerRef?.current?.contentWindow;
    iframe?.postMessage(
      { type: "volume", parameter: hasSound ? "0" : "10" },
      "*",
    );
  };

  return (
    <BillboardPageContext.Provider
      value={{
        highlights,
        setHighlights,
        sections,
        setSections,
        group,
        setGroup,
        backgroundContent,
        setBackgroundContent,
        hasSound,
        setHasSound,
        pandaPlayerRef,
        handleToggleSound,
        setVideoTimeDuration,
        videoTimeDuration,
      }}
    >
      {children}
    </BillboardPageContext.Provider>
  );
};
